import { Input, Icon } from '@chakra-ui/react';
import { LinkIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';
import { LinkBlock as ILinkBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: ILinkBlock;
}

export default function LinkBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <InputGroup flex='1' startElement={<Icon as={LinkIcon} mr={2} w={4} h={4} />} w={'full'}>
        <Input
          id={`block-${block.referenceID}`}
          type={'url'}
          value={payload?.value || ''}
          placeholder='yoursite.com'
          onChange={(e) => updatePayload({ value: e.currentTarget.value })}
        />
      </InputGroup>
    </BaseInputBlock>
  );
}
